import React from 'react'
import { Button, ButtonProps } from './Button'

export const ButtonPrimary: React.SFC<ButtonProps> = props => <Button type="primary" {...props} />
